import { createAction, props } from '@ngrx/store';
import { Signer, UserData } from '@waves/signer';
import BN from '@utils/bn';

// It's a magic enum, provided by waves docs
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum LOGIN_TYPE {
  SIGNER_SEED = 'SIGNER_SEED',
  SIGNER_EMAIL = 'SIGNER_EMAIL',
  KEEPER = 'KEEPER',
  KEEPER_MOBILE = 'KEEPER_MOBILE',
  LEDGER = 'LEDGER',
}

export const rehydrateData = createAction('[Pluto] Rehydrate Data');

export const loadRehydratedDataToService = createAction(
  '[Pluto] Load Rehydrated Data To Service',
);

export const loadRehydratedDataToServiceSuccess = createAction(
  '[Pluto] Load Rehydrated Data To Service Success',
);

export const loadRehydratedDataToServiceFail = createAction(
  '[Pluto] Load Rehydrated Data To Service Failded',
);

export const showLoginModal = createAction('[Pluto] Show Login Modal');

export const hideLoginModal = createAction('[Pluto] Hide Login Modal');

export const selectLoginType = createAction(
  '[Pluto] Select Login Type',
  props<{ loginType: LOGIN_TYPE }>(),
);

export const login = createAction(
  '[Pluto] Login',
  props<{ loginType: LOGIN_TYPE }>(),
);

export const loginSuccess = createAction(
  '[Pluto] Login Success',
  props<{ signer: Signer; loginData: UserData }>(),
);

export const logout = createAction('[Pluto] Logout');

export const logoutSuccess = createAction('[Pluto] Logout Success');

export const showStakeUnstakeModal = createAction(
  '[Pluto] Show Stake Unstake Modal',
  props<{ action: 'stake' | 'unstake' }>(),
);

export const hideStakeUnstakeModal = createAction(
  '[Pluto] Hide Stake Unstake Modal',
);

export const stake = createAction('[Pluto] Stake', props<{ value: BN }>());

export const stakeSended = createAction('[Pluto] Stake Sended');

export const stakeSuccess = createAction('[Pluto] Stake Success');

export const unstake = createAction('[Pluto] Unstake', props<{ value: BN }>());

export const unstakeSended = createAction('[Pluto] Unstake Sended');

export const unstakeSuccess = createAction('[Pluto] Unstake Success');

export const actionInProcess = createAction('[Pluto] Action In Process');

export const getBalances = createAction('[Pluto] Get Balances');

export const getBalancesSuccess = createAction(
  '[Pluto] Get Balances Success',
  props<{ wallet: BN; stake: BN }>(),
);
